<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage path="/Masters"></BacktoPage>
          <Headerlayout
            :headertext="$t('stores.Row.List')"
            :contenttext="$t('stores.Row.TableHeaderContent')"
          >
          </Headerlayout>
        </b-col>
      </b-row>

      <b-row class="py-3">
        <b-col sm="12">
          <div v-if="windowWidth > 545">
            <SkeletonTableLoader :columns="headers" :loading="loading" />
            <div v-if="!loading">
              <MasterEmpty
                v-if="List.length === 0 && !loading"
                eheader="Row Master"
                econtent="Row Master"
                eimg="/src/assets/Img/icons/rackmaster.svg"
                @createNew="IsAdd"
              />
              <div class="table-width-80">
                <Tableview
                  v-if="List.length !== 0"
                  :value="List"
                  :paginator="true"
                  class="p-datatable-gridlines"
                  :rows="10"
                  :rowHover="true"
                  filterDisplay="menu"
                  :loading="loading1"
                  responsiveLayout="scroll"
                  selectionMode="single"
                  :columns="headers"
                  :globalFilterFields="globalFilterFields"
                  :filters="filters"
                  @row-click=""
                  :exceldownload="true"
                  :searchbox="false"
                  :searchbox1="true"
                  @search="SearchOption"
                >
                  <template v-slot:Add>
                    <span class="add">
                      <AddButton
                        @click="IsAdd"
                        :btnname="$t('btn.plusaddnew')"
                        class="float-rights my-3"
                      ></AddButton>
                    </span>
                  </template>
                  <template v-slot:exceldownload>
                    <ExportOption
                      @ExportExcel="ExportExcel"
                      @ExportPDF="ExportPDF"
                      :ExportList="ExportList"
                      PageName="Row Master"
                      :ExportOption="ExportOption"
                      class="ms-2"
                      :HideAndShow="true"
                    />
                  </template>
                  <template v-slot:status="{ data }">
                    <OrangeStatus name="InActive" v-if="data.IsActive == '0'" />
                    <GreenStatus name="Active" v-if="data.IsActive == '1'" />
                  </template>
                  <template v-slot:action="{ data }">
                    <span>
                      <Button
                        icon="pi pi-ellipsis-v"
                        class="p-button-rounded editicon p-button-text"
                        @click="toggle($event, data)"
                      />
                    </span>
                  </template>
                </Tableview>
              </div>
            </div>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" v-for="item in 5" />
            <div v-if="!loading">
              <MasterEmpty
                v-if="List.length === 0 && !loading"
                eheader="Row Master"
                econtent="Row Master"
                eimg="/src/assets/Img/icons/rackmaster.svg"
                @createNew="IsAdd"
              />
              <MobileViewCardHeader>
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in List">
                    <div
                      class="d-flex align-items-center justify-content-between gap-2"
                    >
                      <p class="name">{{ item.Name }}</p>
                      <div class="d-flex align-items-center">
                        <div>
                          <!-- <Badge v-if="item.IsActive == '1'" severity="success">{{
                            "Active"
                            }}</Badge>
                          <Badge v-if="item.IsActive == '0'" severity="warning">{{
                            "InActive"
                            }}</Badge> -->
                          <OrangeStatus
                            name="InActive"
                            v-if="item.IsActive == '0'"
                          />
                          <GreenStatus
                            name="Active"
                            v-if="item.IsActive == '1'"
                          />
                        </div>
                        <i
                          class="pi pi-ellipsis-v"
                          @click="toggle($event, item)"
                        ></i>
                      </div>
                    </div>
                    <p class="light-name">{{ item.StoreName }}</p>
                    <div class="d-flex align-items-center gap-2">
                      <p class="light-name">Branch :</p>
                      <p class="small-name">{{ item.BranchId }}</p>
                    </div>
                    <b-row>
                      <b-col cols="6">
                        <p class="light-name">Room Name</p>
                        <p class="small-name">{{ item.RoomName }}</p>
                      </b-col>
                      <b-col cols="6">
                        <p class="light-name">Rack Name</p>
                        <p class="small-name">{{ item.RackName }}</p>
                      </b-col>
                    </b-row>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>
          <RowCreation
            v-if="showDialog"
            v-model:selected-item="editItems"
            @load="IsShow(), (showDialog = false)"
            @close="showDialog = false"
            @loaderhide="loading = false"
            @loadershow="loading = true"
            :OperationID="ObjOperationId"
            :EntityId="EntityData.EntityId"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>

  <Menu
    ref="menu"
    id="overlay_menu"
    :model="itemListed"
    @click=""
    :popup="true"
  />
  <ActivatedSuccessfully :visible="pop.activatepop" @ok="closetrigger()" />
  <InActivatedSuccessfully :visible="pop.inactivepop" @ok="closetrigger()" />
  <EditConfirmation
    :Editmodel="Editmodel"
    @yes="IsEdit(dataEdit)"
    @no="Editmodel = false"
    :content="$t('confirmation.editcontent')"
  />
  <DeleteConfirmationVue
    :DeleteModel="Deletemodel"
    :content="contentdel"
    @yes="IsDelete(dataEdit)"
    @no="Deletemodel = false"
  />
  <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
  <Mapping
    :visible="MappingPop.visible"
    @ok="closetrigger()"
    :content="MappingPop.content"
  />
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, onUnmounted } from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import RowCreation from "../../../Masters/Stores/RowMaster/RowCreation.vue";

import CommonService from "../../../../../../modules/Inventory/Service/RowService";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { useCommonStore } from "../../../../../../stores/index";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import Mapping from "../../../../../../components/FormComponents/Mapping.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import ActivatedSuccessfully from "../../../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../../../components/FormComponents/InActivateSuccessfully.vue";

import MastersService from "../../../../Service/MastersService";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";
import debounce from "lodash/debounce";

export default defineComponent({
  components: {
    BacktoPage,
    Headerlayout,
    RowCreation,
    Tableview,

    EditConfirmation,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    Mapping,
    MasterEmpty,
    Loader,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
  },
  setup() {
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    const toast = useToast();
    const filter = "";
    const showmodalref = ref(false);
    const childRef = ref();
    let loading1 = ref(false);

    const showDialog = ref(false);
    const rowFocus = ref(false);
    const editItems = ref();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    let List: any = ref([]);
    let CopyList: any = ref([]);
    const MappingPop = ref({
      visible: false,
      content: "",
    });
    let loading = ref(false);
    const pop = ref({
      activatepop: false,
      inactivepop: false,
    });
    const contentdel = ref("");
    let InActivevisible = ref(false);
    let Activevisible = ref(false);
    const datas = ref();
    const menu = ref();

    const headers = [
      {
        header: t("stores.Row.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },

      {
        header: t("stores.Row.branch"),
        field: "BranchName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "smallwidth",
      },
      {
        header: t("stores.Row.store"),
        field: "StoreName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "smallwidth",
      },
      {
        header: t("stores.Row.room"),
        field: "RoomName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "smallwidth",
      },
      {
        header: t("stores.Row.rack"),
        field: "RackName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "smallwidth",
      },
      {
        header: t("stores.Row.name"),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("stores.Row.binlocation"),
        field: "Location",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("stores.Row.status"),
        field: "ActiveStatus",
        fieldDisplay: "false",
        slot: "status",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        fieldDisplay: "false",
        class: "filterdisplaynone last-column-position",
      },
    ];

    let ExportOption = ref("");
    let ExportList = ref([]);

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;
        const result = await CommonService.getRowList();
        console.log(result);
        let count = 0;
        if (usersData.Admin == 1) {
          result["result"] = result["result"]

            .filter((items) => items.HospitalId == usersData.OrganizationId)
            .map((item) => {
              item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
              count = count + 1;
              item.RowNumber = count;

              return item;
            });
        } else {
          result["result"] = result["result"]
            .filter(
              (items) =>
                items.HospitalId == usersData.OrganizationId &&
                items.BranchId == usersData.BranchId
            )
            .map((item) => {
              item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
              count = count + 1;
              item.RowNumber = count;

              return item;
            });
        }
        ExportList.value = result["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", List.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });

    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: { value: null, matchMode: FilterMatchMode.IN, options: List },
      BranchId: { value: null, matchMode: FilterMatchMode.IN, options: List },
      StoreName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      RoomName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
    };
    const data = ref([]);

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };
    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
      window.addEventListener("resize", handleResize);
      IsShow();
      FunctionRights();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });
    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    async function FunctionRights() {
      debugger;
      const response = await MastersService.CheckMenuRights(
        EntityData.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    function toggle(event, data) {
      debugger;
      console.log(event);
      if (data.IsActive == 1) {
        InActivevisible.value = true;
        Activevisible.value = false;
      } else {
        InActivevisible.value = false;
        Activevisible.value = true;
      }

      datas.value = data;
      menu.value.toggle(event);
    }

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: InActivevisible,
            command: async () => {
              IsConfirmEdit(datas.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(datas.value, 0);
            },
          },

          {
            label: "Active",
            icon: "editicon pi pi-check-circle",
            visible: Activevisible,
            command: async () => {
              IsConfirmDel(datas.value, 1);
            },
          },
          {
            label: "InActive",
            icon: "deleteicon pi pi-minus-circle",
            visible: InActivevisible,
            command: async () => {
              IsConfirmDel(datas.value, 2);
            },
          },
        ],
      },
    ]);
    const dataEdit = ref();
    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true &&
        Deletemodel.value == false &&
        showDialog.value == false
      ) {
        // IsEdit(dataEdit.value)
        Editmodel.value = true;
      } else if (
        event.altKey &&
        event.key == "n" &&
        Editmodel.value == false &&
        Deletemodel.value == false
      ) {
        IsAdd();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete(dataEdit.value);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit(dataEdit.value);
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (
        event.key == "d" &&
        rowFocus.value == true &&
        showDialog.value == false &&
        Editmodel.value == false
      ) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Escape" && MappingPop.value.visible == true) {
        MappingPop.value.visible = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      }
    }

    function RowClick(event: any) {
      debugger;
      Editmodel.value = true;
      rowFocus.value = true;
      dataEdit.value = event.data;
    }

    function IsAdd() {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        showDialog.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function IsConfirmEdit(data) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function IsConfirmDel(data, Status) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        data.ActiveStatus = Status;
        dataEdit.value = data;
        Editmodel.value = false;
        if (Status == 1) {
          contentdel.value = t("confirmation.activecontent");
        } else if (Status == 2) {
          contentdel.value = t("confirmation.inactivecontent");
        } else {
          contentdel.value = t("confirmation.deletecontent");
        }
        Deletemodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
      pop.value.activatepop = false;
      pop.value.inactivepop = false;
      MappingPop.value.visible = false;
    }

    //Edit Box
    function IsEdit(data) {
      debugger;
      editItems.value = data;
      showDialog.value = true;
      Editmodel.value = false;
    }

    //Load Room Table
    async function IsShow() {
      loading.value = true;
      debugger;
      try {
        const result = await CommonService.getRowList();
        console.log(result);
        let count = 0;
        // if (usersData.Admin == 1) {
        //   result["result"] = result["result"]
        //     .filter((items) => items.HospitalId == usersData.OrganizationId)
        //     .map((item) => {
        //       item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
        //       count = count + 1;
        //       item.RowNumber = count;
        //       item.Location = `${item.RoomName} ${item.RackName} ${item.Name}`.trim();
        //       return item;
        //     });
        // } else {
        result["result"] = result["result"]
          .filter(
            (items) => {
              const branchIds =
                typeof usersData.BranchId === "string"
                  ? usersData.BranchId.split(",").map(Number)
                  : [usersData.BranchId];
              return (
                items.HospitalId == usersData.OrganizationId &&
                branchIds.includes(items.BranchId)
              );
            }
            // items.HospitalId == usersData.OrganizationId &&
            // items.BranchId == usersData.BranchId
          )
          .map((item) => {
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            count = count + 1;
            item.RowNumber = count;
            item.Location =
              `${item.RoomName} ${item.RackName} ${item.Name}`.trim();
            return item;
          });
        // }

        List.value = result["result"];
        CopyList.value = result["result"];
        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    //Delete Room
    async function IsDelete(data) {
      loading.value = true;
      try {
        let result: any = "";
        if (data.ActiveStatus == 0) {
          result = await CommonService.deleteRow(data.Id);
        } else {
          let status = data.ActiveStatus == 1 ? true : false;
          result = await CommonService.active(data.Id, status);
        }
        let message = result["ErrorInfo"].ErrorCode;
        if (result["result"] != "False" && message == null) {
          Deletemodel.value = false;
          loading.value = false;
          MappingPop.value.content = result["result"];
          MappingPop.value.visible = true;
        } else if (message == null) {
          if (data.ActiveStatus == 1) {
            pop.value.activatepop = true;
          } else if (data.ActiveStatus == 2) {
            pop.value.inactivepop = true;
          } else {
            deletepop.value = true;
          }
          Deletemodel.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch (error) {
        loading.value = false;
      }
    }
    let SearchValue = ref();
    const debouncedSearch = debounce((input) => {
      let regex = new RegExp(input, "i");

      List.value = CopyList.value.filter((item) => {
        return Object.values(item).some((value) => regex.test(String(value)));
      });
    }, 300); // Adjust the delay as needed

    function SearchOption(Input) {
      debugger;
      SearchValue.value = Input;
      debouncedSearch(SearchValue.value);
    }

    return {
      SearchOption,
      SearchValue,
      ObjOperationId,
      data,
      filter,
      showmodalref,
      showpopModal: showmodalref,
      IsShow,
      childRef,
      loading1,
      List,
      headers,
      filters,
      globalFilterFields,
      filteredColumns,
      showDialog: showDialog,
      IsDelete,
      IsConfirmEdit,
      IsConfirmDel,
      Deletemodel,
      closetrigger,
      deletepop,
      dataEdit,
      Editmodel,
      editItems,
      IsEdit,
      RowClick,
      IsAdd,
      MappingPop,
      loading,
      toggle,
      itemListed,
      menu,
      contentdel,
      pop,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
      EntityData,
    };
  },
});
</script>

<style lang="scss" scoped>
.mobilerowname {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.mobilestorename {
  font-size: 14px;
  color: #999999;
}

.mobilestorelabel {
  font-size: 14px;
  font-weight: 600;
}
</style>
